import React, { useEffect, useState } from 'react';
import AutocompleteSearch from '@src/components/atoms/search/autoCompleteSearch';
import { useLazySearchQuery } from '@src/store/search/api';
import { usePathname, useRouter } from 'next/navigation';
import SearchCard from '@src/components/cards/searchCard';
import type { SearchDRepMetadataResponse } from '@src/store/search/types';
import DRepProfileLoading from '@src/components/atoms/dRepProfileLoading';

const DRepSearch = () => {
  const [searchQuery] = useLazySearchQuery();
  const router = useRouter();
  const pathname = usePathname();
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    setIsNavigating(false);
  }, [pathname]);

  const handleSearchQuery = async (term: string) => {
    const result = await searchQuery(term).unwrap();
    return result;
  };

  const handleItemClick = (item: SearchDRepMetadataResponse) => {
    const profilePath = `/drep/${item.meta.drepIdCip129}`;
    if (pathname === profilePath) return;

    setIsNavigating(true);
    router.push(profilePath);
  };

  return (
    <>
      <AutocompleteSearch
        searchQuery={handleSearchQuery}
        placeholder="Search DReps..."
        renderItem={(item, index) => <SearchCard key={index} item={item} />}
        onItemClick={handleItemClick}
      />
      {isNavigating && <DRepProfileLoading overlay />}
    </>
  );
};

export default DRepSearch;
